
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { RoomFormData } from "@/types/hotel";
import { weekDays } from "./constants";

interface RoomDialogWeeklyPricingProps {
  formData: RoomFormData;
  setFormData: React.Dispatch<React.SetStateAction<RoomFormData>>;
  handleWeekPriceChange: (day: string, price: string) => void;
}

export const RoomDialogWeeklyPricing = ({ formData, setFormData, handleWeekPriceChange }: RoomDialogWeeklyPricingProps) => {
  return (
    <>
      <div className="space-y-2">
        <div className="flex items-center space-x-2 space-x-reverse">
          <Switch
            id="is_weekly_pricing"
            checked={formData.is_weekly_pricing}
            onCheckedChange={(checked) => setFormData(prev => ({ ...prev, is_weekly_pricing: checked }))}
          />
          <Label htmlFor="is_weekly_pricing">تسعير أسبوعي</Label>
        </div>
      </div>

      {formData.is_weekly_pricing && (
        <div className="space-y-2">
          <Label>أسعار أيام الأسبوع</Label>
          <div className="grid grid-cols-2 gap-3">
            {weekDays.map((day) => (
              <div key={day.key} className="flex items-center space-x-2 space-x-reverse">
                <Label className="min-w-[60px] text-sm">{day.label}</Label>
                <Input
                  type="number"
                  value={formData.week_prices?.[day.key] || ''}
                  onChange={(e) => handleWeekPriceChange(day.key, e.target.value)}
                  placeholder="0"
                  min="0"
                  step="0.01"
                  className="flex-1"
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
